import React, { useEffect, useState } from 'react'
import { FieldTypes } from '../../utils/constants'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import Form from '../common/Form'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'

export default function BlacklistedForm({
  onSubmit,
  handleCancel,
  building,
  blacklisted,
}) {
  const classes = useStyles()
  const history = useHistory()

  const [values, setValues] = useState(blacklisted || {})

  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()

  useEffect(() => {
    const fetchBuildingData = async () => {
      getBuildings()
    }
    fetchBuildingData()
  }, [])

  return (
    <div className={classes.paper}>
      <ListHeader
        bigTitle={values.id ? 'Editar restringido' : 'Nuevo restringido'}
        canCreate={false}
      />
      <Form
        values={values}
        setValues={setValues}
        fields={[
          {
            type: FieldTypes.TextField,
            label: 'Cédula',
            hint: 'Ingrese una cédula',
            key: 'ci',
            errorMessage: 'La cédula es requerida',
            numeric: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Nombre',
            hint: 'Ingrese un nombre',
            key: 'name',
            errorMessage: 'El nombre es requerido',
            onlyLetters: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Observaciones',
            hint: 'Ingrese observaciones',
            key: 'observation',
            withMargin: true,
          },
          ...(!building
            ? [
                {
                  type: FieldTypes.Autocomplete,
                  label: 'Cliente',
                  hint: 'Seleccione un cliente',
                  key: 'buildingId',
                  options: buildingsState.buildings,
                  multiple: false,
                  freeSolo: false,
                  withMargin: true,
                  onChange: (value) => {
                    setValues({ ...values, buildingId: value.id })
                  },
                  errorMessage: 'El cliente es requerido',
                },
              ]
            : []),
        ]}
        handleSubmit={() => {
          onSubmit(values)
          history.push('/restringidos')
        }}
        handleCancel={handleCancel}
      />
    </div>
  )
}
